import Actions from '../../../constants/inventory/InventoryActions';
import { RemoveActionLabels } from '../../../constants/inventory/Reasons';

const {
  REMOVE,
  DAMAGED,
  SPOILED,
  LOST,
  EXPIRED,
  STOLEN,
  DONATION_REMOVED,
  DONATED,
  REMOVE_CORRECTION,
  SOLD,
  DISTRIBUTED
} = Actions;

export default [
  { value: REMOVE, label: RemoveActionLabels[REMOVE] },
  { value: DONATION_REMOVED, label: RemoveActionLabels[DONATION_REMOVED] },
  { value: REMOVE_CORRECTION, label: RemoveActionLabels[REMOVE_CORRECTION] },
  { value: DONATED, label: RemoveActionLabels[DONATED] },
  { value: DISTRIBUTED, label: RemoveActionLabels[DISTRIBUTED] },
  { value: SOLD, label: RemoveActionLabels[SOLD] },
  { value: DAMAGED, label: RemoveActionLabels[DAMAGED] },
  { value: SPOILED, label: RemoveActionLabels[SPOILED] },
  { value: LOST, label: RemoveActionLabels[LOST] },
  { value: EXPIRED, label: RemoveActionLabels[EXPIRED] },
  { value: STOLEN, label: RemoveActionLabels[STOLEN] }
];
